module.exports = __webpack_public_path__ + "static/media/myBusiness.82badced.png";